module.exports = __webpack_public_path__ + "img/empty-feed.5c83a6bd.svg";